import { AppStateProvider } from '@sky-distribution/gp-onboarding-app-state-service';
import { BrowserRouting, useLocation } from '@sky-distribution/gp-onboarding-shared-components';
import { Themed } from '@sky-distribution/react-commons-ui';
import { FC } from 'react';
import { I18nextProvider } from 'react-i18next';
import { ProductConfigurationModule } from './config';

export const Bootstrap: FC<{
  productId: string;
  options?: Record<string, unknown>;
  config: ProductConfigurationModule;
}> = ({ options, productId, config }) => {
  const { pathname } = useLocation();
  const {
    theme, i18n, App, machineConfiguration, getContextConfiguration, restartOnSearchParams,
  } = config;

  return (
    <I18nextProvider i18n={i18n}>
      <AppStateProvider
        pathname={pathname}
        productId={productId}
        machineConfig={machineConfiguration}
        interpreterOptions={options}
        getContextConfiguration={getContextConfiguration}
        restartOnSearchParams={restartOnSearchParams}
      >
        <BrowserRouting>
          <Themed theme={theme}>
            <App />
          </Themed>
        </BrowserRouting>
      </AppStateProvider>
    </I18nextProvider>
  );
};
